// extracted by mini-css-extract-plugin
module.exports = {"head":"SectionHead_head__ZNfVn","text":"SectionHead_text__MYMVa","title":"SectionHead_title__TN15L","description":"SectionHead_description__GPVPZ","link":"SectionHead_link__h2u6w"};